<template>
  <div>
    <div class="row">
      <div class="col col-lg-6" style="display: flex; justify-content: space-between;">
        <h3>{{ header }}</h3>
        <div v-if="status">
          <span
            :class="'ignore pointer badge ' + getStyle(status)" 
          >
            {{ status.statusName || status.oppStatusName || status.activityStatusName }}
          </span>
        </div>
      </div>
      <div class="col col-lg-6" v-if="specialMessage">
        <strong style="color: red;">{{ specialMessage }}</strong>
      </div>
    </div>
    <div class="row">
      <div 
        v-for="(item, index) in values" 
        :key="index"
        :class="getClass(index)"
        style="padding-down:15px;"  
      >
        <div v-if="index !== 3">
            <label for="code">{{
              item.title
            }}</label>
            <div v-if="item.title === 'Status:' && typeof item.description === 'object'">
              <span
                :class="'ignore pointer badge ' + getStyle(item.description)" 
              >
                {{ item.description.statusName || item.description.oppStatusName }}
              </span>
            </div>
            <div v-else>
              <InputText
                class="clearer"
                type="text"
                placeholder=""
                disabled="true"
                :value="item.description"
                style="width: 100%;"
              ></InputText>
            </div>
        </div>
        <div v-else>
          <div
            style="padding-top: 26px;"
          >
            <Button
              :label="getLabel()"
              icon="pi pi-pencil"
              class="p-button-success p-mr-2"
              style="width: 100%;"
              @click="edit()"
            />
          </div>
        </div>
      </div>
    </div>

    <hr />

  </div>
</template>
<script>
export default {
  props: ["header", "values", "specialMessage", "status"],
  methods: {
    getStyle(data) {
      
      // according to: https://www.w3schools.com/bootstrap4/tryit.asp?filename=trybs_badges2&stacked=h
      if (data && data.colourCode) {
        return data.colourCode
      } else if (data && data.statusName && data.statusName.toLowerCase() === 'lost') {
        return 'badge-danger'
      } else if (data && data.statusName && data.statusName.toLowerCase() === 'active') {
        return 'badge-primary'
      } else if (data && data.statusName && data.statusName.toLowerCase() === 'won') {
        return 'badge-success'
      } else if (data && data.statusName && data.statusName.toLowerCase() === 'completed') {
        return 'badge-success'
      } else if (data && data.statusName && data.statusName.toLowerCase() === 'cancelled') {
        return 'badge-warning'
      } else if (data && data.statusName && data.statusName.toLowerCase() === 'task') {
        return 'badge-warning'
      } else if (data && data.statusName && data.statusName.toLowerCase() === 'revised') {
        return 'badge-info'
      } else if (data && data.statusName && data.statusName.toLowerCase() === 'closed') {
        return 'badge-secondary'
      } else {
        return 'badge-dark'
      }
    },
    getClass(index) {
      switch(index) {
        case 0: {
          return 'col col-md-6 col-lg-2'
          break
        }
        case 1: {
          return 'col col-md-6 col-lg-5'
          break
        }
        case 2: {
          return 'col col-md-6 col-lg-2'
          break
        }
        case 3: {
          return 'col col-md-6 col-lg-3'
          break
        }
      }
    },
    edit() {
      this.$emit('edit')
    },
    getLabel() {
      let a = this.header.split(' ')
      return "Edit " + a[0]
    }
  }
};
</script>

<style scoped>

.pointer {
  cursor: auto;
  font-size: 16px;
}

</style>